import {
  ErrorHandler,
  NgModule,
  inject,
  provideAppInitializer
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import {
  TranslateCompiler,
  TranslateModule
} from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import * as Sentry from '@sentry/angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { provideCoreStore } from './store';
import { LocaleInterceptor } from './shared/interceptors/locale.interceptor';
import { Router } from '@angular/router';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';
import { injectNewRelicBrowserAgent } from './newrelic';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json'
      }),
      compiler: {
        provide: TranslateCompiler,
        useClass: TranslateMessageFormatCompiler
      },
      isolate: false
    })
  ],
  providers: [
    provideCoreStore(),
    { provide: HTTP_INTERCEPTORS, useClass: LocaleInterceptor, multi: true },
    provideAppInitializer(() => {
      injectNewRelicBrowserAgent();
    }),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false
      })
    },
    {
      provide: Sentry.TraceService,
      deps: [Router]
    },
    provideAppInitializer(() => {
      // inject the TraceService here so Angular creates it
      inject(Sentry.TraceService);
      const initializerFn = () => {};
      return initializerFn();
    })
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
